import { yupResolver } from '@hookform/resolvers/yup';
import { Resolver } from 'react-hook-form';
import { AddDialogMessage } from 'shared/api/types/dialog_messages';
import * as Yup from 'yup';
import initDefaultSchema from '../yupConfig';

initDefaultSchema();

// Create message
export type CreateMessageFormT = Omit<AddDialogMessage['request'], 'block'>;
export const getCreateMessageValues = (): CreateMessageFormT => ({
  text: '',
  clientID: null,
  clientName: '',
  status: 'Create',
  position: 'End',
});
const createMessageSchema: Yup.ObjectSchema<CreateMessageFormT> = Yup.object({
  text: Yup.string().required(),
  clientID: Yup.number().typeError('Client is required').required(),
  clientName: Yup.string().required(),
  status: Yup.string().oneOf(['Create', 'Edit', 'Send']).required(),
  position: Yup.string().oneOf(['Start', 'End']).default('End'),
});
export const createMessageResolver = yupResolver(createMessageSchema) as Resolver<CreateMessageFormT>;
